export const FeatureFlagEnum = {
  actPermissionsEnabled: 'fe.enable-act-permissions',
  actSettingsEnabled: 'fe.enable-act-settings',
  aiSummaries: 'is-ai-summaries-enabled',
  allPerspectiveDepartment: 'be.all-perspective-department',
  dataDog: 'datadog-logs-fe',
  dataDogRUM: 'datadog-rum',
  departmentSelectGroupDirectChildren: 'fe.department-select-group-direct-children',
  generateAiActions: 'fe.enable-generate-ai-actions',
  intercom: 'fe.enable-intercom',
  newActionHighlight: 'fe.new-action-highlight',
  perspectivesV2: 'fe.is-perspectives-v2-enabled',
  perspectivesV2Mocks: 'fe.is-perspectives-v2-mocks-enabled',
  postHog: 'posthog-core',
  tailorActionSuggestions: 'fe.enable-tailor-action-suggestions',
} as const;

export type FeatureFlagEnum = typeof FeatureFlagEnum[keyof typeof FeatureFlagEnum];
